document.addEventListener('DOMContentLoaded', function(){
  var btn = document.querySelector('[data-hr-menu-toggle]');
  var header = document.querySelector('[data-hr-header]');
  if(btn && header){
    btn.addEventListener('click', function(){
      var open = header.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-hr-back]').forEach(function(link){
    link.addEventListener('click', function(event){
      if(window.history.length > 1){event.preventDefault();window.history.back();}
    });
  });
});

(function(){
  var loader=document.querySelector('[data-hr-loader]');
  function finishLoading(){if(loader)loader.classList.add('is-complete');}
  if(document.readyState==='complete')finishLoading();
  else window.addEventListener('load',finishLoading,{once:true});
  window.setTimeout(finishLoading,1800);

  var cursor=document.querySelector('[data-hr-cursor]');
  if(!cursor||!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
  document.addEventListener('pointermove',function(event){
    cursor.style.left=event.clientX+'px';
    cursor.style.top=event.clientY+'px';
    cursor.classList.add('is-visible');
  },{passive:true});
  document.addEventListener('pointerleave',function(){cursor.classList.remove('is-visible');});
  document.addEventListener('pointerover',function(event){
    cursor.classList.toggle('is-active',Boolean(event.target.closest('a,button,[role="button"],input,select')));
  });
})();

(function(){
  function initCollectionSwipe(root){
    (root||document).querySelectorAll('.hr-collection-grid .hr-product-card').forEach(function(card){
      var slides=Array.prototype.slice.call(card.querySelectorAll('[data-card-slide]'));
      if(card.dataset.swipeReady==='true'||slides.length<2)return;
      card.dataset.swipeReady='true';
      var image=card.querySelector('.hr-product-card__image');
      var dots=Array.prototype.slice.call(card.querySelectorAll('[data-card-dot]'));
      var startX=0,startY=0,swiped=false,index=0;
      function showSlide(nextIndex){
        index=(nextIndex+slides.length)%slides.length;
        card.classList.add('has-gallery-state');
        slides.forEach(function(slide,i){slide.classList.toggle('is-active',i===index);slide.setAttribute('aria-hidden',i===index?'false':'true');});
        dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===index);});
        card.setAttribute('aria-label','Product image '+(index+1)+' of '+slides.length+'. Swipe for more photos.');
      }
      showSlide(0);
      image.addEventListener('pointerdown',function(event){startX=event.clientX;startY=event.clientY;swiped=false;},{passive:true});
      image.addEventListener('pointerup',function(event){
        var dx=event.clientX-startX,dy=event.clientY-startY;
        if(Math.abs(dx)<35||Math.abs(dx)<=Math.abs(dy))return;
        swiped=true;
        showSlide(index+(dx<0?1:-1));
      },{passive:true});
      card.addEventListener('click',function(event){if(swiped){event.preventDefault();swiped=false;}});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initCollectionSwipe(document);});
  else initCollectionSwipe(document);
  document.addEventListener('shopify:section:load',function(event){initCollectionSwipe(event.target);});
})();

(function(){
  function initProductGallery(root){
    var galleries=(root||document).querySelectorAll('[data-product-gallery]');
    galleries.forEach(function(gallery){
      if(gallery.getAttribute('data-gallery-ready')==='true')return;
      var section=gallery.closest('.shopify-section')||gallery.closest('.hr-product')||document;
      var mainButton=gallery.querySelector('[data-product-main-trigger]');
      var mainImage=gallery.querySelector('.hr-product__main-image');
      var expandButton=gallery.querySelector('[data-product-expand]');
      var zoomHint=gallery.querySelector('[data-product-zoom-hint]');
      var lightbox=section.querySelector('[data-product-lightbox]');
      var lightboxImage=section.querySelector('[data-product-lightbox-image]');
      var closeButton=section.querySelector('[data-product-lightbox-close]');
      if(!mainButton||!mainImage)return;
      gallery.setAttribute('data-gallery-ready','true');

      gallery.addEventListener('click',function(event){
        var thumb=event.target.closest('[data-product-thumb]');
        if(!thumb||!gallery.contains(thumb))return;
        event.preventDefault();
        var src=thumb.getAttribute('data-image-src');
        var zoomSrc=thumb.getAttribute('data-zoom-src')||src;
        var alt=thumb.getAttribute('data-image-alt')||'';
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.setAttribute('src',src);
        mainImage.setAttribute('alt',alt);
        mainButton.setAttribute('data-zoom-src',zoomSrc);
        mainButton.classList.remove('is-zoomed');
        mainButton.setAttribute('aria-pressed','false');
        if(zoomHint)zoomHint.textContent='Click to magnify';
        if(lightboxImage){lightboxImage.setAttribute('src',zoomSrc);lightboxImage.setAttribute('alt',alt);}
        gallery.querySelectorAll('[data-product-thumb]').forEach(function(item){
          var active=item===thumb;
          item.classList.toggle('is-active',active);
          item.setAttribute('aria-current',active?'true':'false');
        });
      });

      mainButton.addEventListener('click',function(event){
        event.preventDefault();
        var zoomed=mainButton.classList.toggle('is-zoomed');
        mainButton.setAttribute('aria-pressed',zoomed?'true':'false');
        if(zoomHint)zoomHint.textContent=zoomed?'Click to reduce':'Click to magnify';
      });
      mainButton.addEventListener('pointermove',function(event){
        if(!mainButton.classList.contains('is-zoomed'))return;
        var rect=mainButton.getBoundingClientRect();
        mainImage.style.transformOrigin=(((event.clientX-rect.left)/rect.width)*100)+'% '+(((event.clientY-rect.top)/rect.height)*100)+'%';
      });
      mainButton.addEventListener('pointerleave',function(){mainImage.style.transformOrigin='50% 50%';});

      function openLightbox(){
        if(!lightbox||!lightboxImage)return;
        lightboxImage.setAttribute('src',mainButton.getAttribute('data-zoom-src')||mainImage.src);
        lightboxImage.setAttribute('alt',mainImage.alt||'Product image');
        lightbox.hidden=false;
        document.documentElement.classList.add('hr-lightbox-open');
        if(closeButton)closeButton.focus();
      }
      function closeLightbox(){
        if(!lightbox)return;
        lightbox.hidden=true;
        document.documentElement.classList.remove('hr-lightbox-open');
        if(expandButton)expandButton.focus();
      }
      if(expandButton)expandButton.addEventListener('click',function(event){event.preventDefault();event.stopPropagation();openLightbox();});
      if(closeButton)closeButton.addEventListener('click',closeLightbox);
      if(lightbox)lightbox.addEventListener('click',function(event){if(event.target===lightbox)closeLightbox();});
      document.addEventListener('keydown',function(event){if(event.key==='Escape'&&lightbox&&!lightbox.hidden)closeLightbox();});
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initProductGallery(document);});
  else initProductGallery(document);
  document.addEventListener('shopify:section:load',function(event){initProductGallery(event.target);});
})();
